// Utils
import { searchingAction } from './searchingAction';
/**
 * Handle every keystroke of the dropdown input
 *
 * @param {Dispatch<DropdownReducerAction>} dispatch
 */
export var handleDropdownInputValue = function (dispatch) {
    return function (handleValue) {
        return function (value) {
            dispatch(searchingAction);
            handleValue(value);
        };
    };
};
//# sourceMappingURL=handleDropdownInputValue.js.map